"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai-assist.suggestions.header': 'Sugerencias de IA',
    'ai-assist.suggestions.close': 'Cerrar',
    'ai-assist.suggestions.intro': 'Selecciona una sugerencia para aplicarla a tu prompt:',
};
